import { createContext } from 'react'
import { Theme } from 'features/ui/types'
import { DomainStrings } from 'enums/Domain'
import { MediaTypeStrings } from 'enums/MediaType'

export type Metric = 'retweets' | 'replies' | 'shares' | 'comments' | 'likes' | 'reblogs' | 'views'

export interface MediaCardProps {
  mediaType?: MediaTypeStrings
  mediaUrl?: string
  thumbnailUrl?: string
  domain?: DomainStrings
  dataStream?: string
  engagements?: number
  footer: Map<Metric, number | undefined>
  hasMultipleMedia?: boolean
  onClick?: () => void
}

const MediaCardContext = createContext<
  MediaCardProps & {
    mode: Theme
    isError: boolean
  }
>({
  mediaType: 'Image',
  mediaUrl: undefined,
  thumbnailUrl: undefined,
  domain: undefined,
  dataStream: undefined,
  engagements: undefined,
  footer: new Map(),
  hasMultipleMedia: false,
  mode: 'light',
  isError: false,
  onClick: undefined
})
export default MediaCardContext
